import * as React from 'react';
import { createComponent } from '@lit/react';
import { CarouselItemWC } from './carousel-item.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../component-types-generics';

export type CarouselItemProps =
  GenerateComponentTypeWithChildren<CarouselItemWC>;

export type CarouselItemPropsWithRef = GeneratePropsWithRef<CarouselItemProps>;

export const CarouselItem = createComponent({
  tagName: CarouselItemWC.tagname,
  elementClass: CarouselItemWC,
  react: React,
}) as CarouselItemPropsWithRef;
